module.exports = {"apiKey":"AIzaSyDnC8N_ZXp9jg20r0RJO963lmTbiGmJ_Ns","authDomain":"werksoft-eternal-push-messages.firebaseapp.com","databaseURL":"https://werksoft-eternal-push-messages.firebaseio.com","projectId":"werksoft-eternal-push-messages","storageBucket":"werksoft-eternal-push-messages.appspot.com","messagingSenderId":"147197313206"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase-config.json
// module id = Kufx
// module chunks = 1